import { render, staticRenderFns } from "./orderDetailcc.vue?vue&type=template&id=66bacf67&scoped=true"
import script from "./orderDetailcc.vue?vue&type=script&lang=ts"
export * from "./orderDetailcc.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailcc.vue?vue&type=style&index=0&id=66bacf67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bacf67",
  null
  
)

export default component.exports